import { Badge, MantineColor } from "@mantine/core";
import classes from "./Tag.module.css";

const Tag = (color: MantineColor, name: string) => {
  if (color.slice(0, 1) === "#")
    return (
      <Badge
        style={{ "--tag-color": color } as React.CSSProperties}
        classNames={{ root: classes.hexRoot }}
        size="md"
        radius="lg"
        variant="outline"
        styles={{ label: { overflow: "visible", textOverflow: "unset" } }}>
        {name}
      </Badge>
    );
  else
    return (
      <Badge color={color} size="md" radius="lg" variant="outline" styles={{ label: { overflow: "visible", textOverflow: "unset" } }}>
        {name}
      </Badge>
    );
};

export { Tag };
